import { Breadcrumb } from "antd";
import { useIntl } from "react-intl"; // Assuming you are using 'react-intl' for internationalization
import { Link, useLocation } from "react-router-dom";

const useBreadcrumb = (
  lastSegment?: string | string[],
  separator: number = 0
) => {
  const location = useLocation();
  const intl = useIntl(); // For internationalization

  const getPathItems = () => {
    let pathSegments = location.pathname.split("/").filter(Boolean);

    // Determine how many segments to replace based on the lastSegment array length
    const segmentCountToReplace = Array.isArray(lastSegment)
      ? lastSegment.length
      : 0;
    const startIndexToReplace = pathSegments.length - segmentCountToReplace;

    return pathSegments.map((segment, index, array) => {
      const path = `/${array.slice(0, index + 1).join("/")}`;
      const isLast = index === array.length - 1; // Check if current segment is the last one

      if (Array.isArray(lastSegment) && index >= startIndexToReplace) {
        const replacementIndex = index - startIndexToReplace;
        const title = lastSegment[replacementIndex];

        if (isLast) {
          return {
            title: (
              <div className="!text-color-primary capitalize">{title}</div>
            ),
          };
        } else {
          return {
            title: (
              <Link to={path} className="!text-[#9999A7] capitalize">
                {title}
              </Link>
            ),
          };
        }
      } else {
        const title = intl.formatMessage({
          id: segment,
          defaultMessage: segment,
        });

        if (isLast) {
          return {
            title: (
              <div className="!text-color-primary capitalize">{title}</div>
            ),
          };
        } else {
          return {
            title: (
              <Link to={path} className="!text-[#9999A7] capitalize">
                {title}
              </Link>
            ),
          };
        }
      }
    });
  };

  const breadcrumbItems = getPathItems();
  return (
    <Breadcrumb
      className=""
      separator={separator ? "/" : ">"}
      items={breadcrumbItems}
    />
  );
};

export default useBreadcrumb;
